import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import venue from './modules/venue'
import products from './modules/products'
import productCatalog from './modules/productCatalog'
import ui from './modules/ui'
import cart from './modules/cart'
import payment from './modules/payment'
import user from './modules/user'
import events from './modules/events/'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	modules: {
		venue,
		products,
		productCatalog,
		ui,
		cart,
		payment,
		user,
		events
	},
	plugins: debug ? [createLogger()] : []
})
